
    $(function () {

        // test.test1Fn(); // - prijenos funkcije
        // test.test2Fn(); // - prijenos funkcije

        // elementi modal elementa (za animaciju)
        var search          = $('.js_search'),
            mainNav         = $('.js_mainNav');

        // elementi za animaciju
        var wWidth     = jQuery(window).width(),
            wHeight    = jQuery(window).height();

        var no_transition = $('body').hasClass('no-csstransitions');

        var $toggMenu           = $('.js_toggleMenu');
        var $showNotif          = $('.js_showNotif');
        var $closeNav           = $('.js_closeNavigation');
        var $toggSubmenu        = $('.js_subnavToggle');
        var $closeSubmenu       = $('.js_closeSubmenu');
        var $sticky             = $('.js_sticky');
        var $ntfs               = $('.js_ntfs');
        var $ntfsClose          = $('.js_ntfsClose');
        var $ntfsMarkSeen       = $('.js_markAsSeen');
        var $toggSearch         = $('.js_toggleSearch');
        var $toggObavijesti     = $('.js_openObavijesti');
        var $showPartnerSites   = $('.js_showPartnerSites');

        //function setActiveNav
        //gore navedena funkcija sluzi za zapis is_active klase na trenutnu rubriku/podrubriku
        //ova funkcija je napisana u header.html zbog brzine, da se ne ceka izvrsavanje cijelog js-a

        var showMenu = function ( $obj, e ) {

            e.preventDefault();

            $('body').toggleClass('has_navigation');

            if( !$('body').hasClass('has_navigation') ) {

                $('body').removeClass('has_subnavigation');

                //$toggSubmenu.siblings('.sub_nav').removeClass('is_opened');

                //linija gore prebrikana s linijom ispod

                $toggSubmenu.siblings('.main_nav__subnav_wrap').find('.sub_nav').removeClass('is_opened');
            }
        };




        var showSubmenu = function ( $obj, e ) {

            e.preventDefault();

            //$('.js_subnavToggle').siblings('.sub_nav').removeClass('is_opened');

            //linija iznad prebrikana s linijom ispod

            $('.js_subnavToggle').siblings('.main_nav__subnav_wrap').find('.sub_nav').removeClass('is_opened');

            //$obj.siblings('.sub_nav').addClass('is_opened');

            //linija iznad prebrikana s linijom ispod

            $obj.siblings('.main_nav__subnav_wrap').find('.sub_nav').addClass('is_opened');

            if( $obj.hasClass('is_opened') ) {

                $('body').removeClass('has_subnavigation');

            } else {

                $('body').addClass('has_subnavigation');

            }
        };


        var closeSubmenu = function ( $obj, e ) {

            e.preventDefault();

            //$('.js_subnavToggle').siblings('.sub_nav').removeClass('is_opened');

            //linija iznad prebrikana s linijom ispod

            $('.js_subnavToggle').siblings('.main_nav__subnav_wrap').find('.sub_nav').removeClass('is_opened');

            $('body').removeClass('has_subnavigation');

        }


        var showPartnerSites = function ( $obj, e ) {

            e.preventDefault();

            $obj.siblings('.footer_nav').addClass('is_opened');
            $obj.remove();

        }



        var showNotif = function ( $obj, e ) {

            e.preventDefault();

            $('body').addClass('has_notif');
            $ntfs.addClass('is_opened');
        };



        var hideNotif = function () {

            $('body').removeClass('has_notif');
            $ntfs.removeClass('is_opened');
        };





        var markAsSeen = function ( $obj, e ) {

            e.preventDefault();

            $.ajax({

                type: "POST",
                url: $obj.data('api'),

                success: function(data) {

                    $('.js_showNotif')
                        .find('.toggle__count')
                        .fadeOut( function(){
                            $(this).remove();
                        } );

                    $('.ntfs .ntfs__link').addClass('ntfs__link--seen');

                },

                statusCode: {

                    201: function() {
                        // console.log('Uspješno');
                    },

                    403: function() {
                        // console.log('Korisnik nije logiran');
                    },

                    408: function() {
                        // console.log('Problem sa serverom - Pokušajte kasnije');
                    },

                    500: function() {
                        // console.log('Problem sa serverom - Pokušajte kasnije');
                    },

                    502: function() {
                        // console.log('Problem sa serverom - Pokušajte kasnije');
                    }
                }
            });
        };

        // open/close search bar
        var showSearch = function ( $obj, e ) {

            e.preventDefault();

            if( search.hasClass('search--open') ) {

                search.removeClass('search--open');
                search.addClass('search--close');

                mainNav.removeClass('search--open');
                mainNav.addClass('search--close');

            } else {


                search.removeClass('search--close');
                search.addClass('search--open');

                mainNav.removeClass('search--close');
                mainNav.addClass('search--open');

                search.find('.search__txt').focus();

           }
        };


        var showInfo = function ( $obj, e ) {

            e.preventDefault();

            var styModal = $obj.styModal({

                onBeforeClose: function() {
                    $('.js_openObavijesti .notiff__count').remove();
                }
            });
        };




        var closeNavigation = function () {

            $('body').removeClass('has_navigation has_subnavigation');
            $('.js_subnavToggle').removeClass('is_opened');
        };





        function setTopSubnavigation () {

            var $topNav         = $('.top_navigation');
            var $subnavWrap     = $('.js_subnavWrap');

            if( !$subnavWrap.length ) { return; }

            var $activeNavItem  = $topNav.find('.main_nav__link.is_active');
            //var $subnav         = $activeNavItem.siblings('.sub_nav');

            //linija iznad prebrikana s linijom ispod

            var $subnav         = $activeNavItem.siblings('.main_nav__subnav_wrap').find('.sub_nav');

            var navSection = $activeNavItem.attr('class');

            if( navSection ) {

                navSection = navSection
                    .split('main_nav__link').join('')
                    .split('is_active').join('')
                    .split('active_').join('');
            }

            $subnav
                .find('.main_nav__span')
                .addClass('bd--' + navSection.trim());

            if( $subnav.find('.is_active').length ) {

                $subnavWrap.addClass('has_active');
            }

            $subnavWrap
                .html($subnav)
                .addClass('is_visible');
        }




        function setSubnavigation () {

            var $topNav = $('.top_navigation');
        }




        $(document).mouseup(function (e){

            var $container = $('.js_sideNav');

                                                        // if the target of the click isn't the container && nor a descendant of the container
            // if ($('body').hasClass('has_navigation') && !$container.is(e.target) && $container.has(e.target).length === 0) {
//
            //     closeNavigation();
            // }


            var $container2 = $('.js_ntfs');
                                                      // if the target of the click isn't the container && nor a descendant of the container
            if ($container2.hasClass('is_opened') && !$container2.is(e.target) && $container2.has(e.target).length === 0) {

                hideNotif();
            }

        });



        var unloggedNotif = function() {

            var $ntfsUnloged = $('.js_ntfsGuest').first();
            var $ntfsUnread = $('.js_ntfsUnread');

            if ( !$ntfsUnloged.length ) { return; }

            var cookieKey = $ntfsUnloged.data('key');
            var cookieNTFS = cookieKey + '_ntfs';

            var cookieIDS = $.cookie( cookieKey );
            if ( !cookieIDS ) { return; }
            var cookie = JSON.parse('[' + cookieIDS+ ']');

            // var ntfsIDS = '{"15":"read","24":"read","30":"read"}';
            var ntfsIDS = $.cookie( cookieNTFS );

            var ntfs = {};
            if ( ntfsIDS ) {
                ntfs = JSON.parse(ntfsIDS);
            }

            // checking for new keys
            function updateNTFS(testID) {

                if ( isNaN(Number(testID))) { return; } // id je uvijek broj

                for (var id in ntfs) {
                    if (id == testID) {
                        return;
                    }
                }

                ntfs[testID] = 'unread';
            }

            for (var id in cookie) {
                updateNTFS(cookie[id]);
            }

            // delete old keys
            function cleanNTFS () {
                for (var key in ntfs) {
                    if (cookie.indexOf(Number(key)) == -1) {
                        delete ntfs[key];
                    }
                }
            }

            function unreadNTFS(){

                var i = 0;
                for (var id in ntfs) {
                    if (ntfs[id] == 'unread') {
                        i++;
                    }
                }

                if(i > 0) {

                    if( !$('.js_NTFSCount').length ){
                        var countTempl = '<span class="toggle__count js_NTFSCountContainer"><span class="toggle__count_correction js_NTFSCount"></span></span>';
                        $('.js_notificationsShow').append( countTempl );
                    }

                    $('.js_NTFSCount').text(i);
                } else {
                    $('.js_NTFSCountContainer').remove();
                }
            }

            function markNTFS(ID) {

                if (ntfs[ID]) {
                    ntfs[ID] = 'read';
                }
            }

            $ntfsUnread.on('click', function(){
                var $link = $(this);

                var linkID = $link.data('ntfsid');
                markNTFS( linkID );
                unreadNTFS();

                $.cookie( cookieNTFS, JSON.stringify( ntfs ), { expires: 365, path: '/' });
            });

            cleanNTFS();
            unreadNTFS();
            $.cookie( cookieNTFS, JSON.stringify( ntfs ), { expires: 365, path: '/' });

        };


        // Eventi za navigaciju
        $toggMenu.on            ('click', function(e){ showMenu         ( $(this), e ); });
        $showNotif.on           ('click', function(e){ showNotif        ( $(this), e ); });
        $toggSubmenu.on         ('click', function(e){ showSubmenu      ( $(this), e ); });
        $closeSubmenu.on        ('click', function(e){ closeSubmenu     ( $(this), e ); });
        $toggSearch.on          ('click', function(e){ showSearch       ( $(this), e ); });
        $toggObavijesti.on      ('click', function(e){ showInfo         ( $(this), e ); });
        $ntfsMarkSeen.on        ('click', function(e){ markAsSeen       ( $(this), e ); });
        $showPartnerSites.on    ('click', function(e){ showPartnerSites ( $(this), e ); });

        $closeNav.on        ('click', function(e){ e.preventDefault(); closeNavigation  ( $(this), e ); });
        $ntfsClose.on       ('click', function(e){ e.preventDefault(); hideNotif        ( $(this), e ); });

        // setTopSubnavigation();
        setSubnavigation();
        unloggedNotif();
    });
